import { ReactComponent as UserIconSvg } from "./user.svg";
const UserIcon = (props) => {
  return <UserIconSvg {...props} />;
};
export default UserIcon;
